import React from "react";
import Iconify from "../../../../layouts/components/iconify/iconify";

const KPI_ITEMS = [
  {
    key: "totalTask",
    label: "Total Tasks",
    icon: "mdi:task-auto",
    tone: "total",
  },
  {
    key: "inProgressTask",
    label: "In Progress",
    icon: "carbon:in-progress",
    tone: "inprogress",
  },
  {
    key: "pendingTask",
    label: "Pending",
    icon: "fluent:checkmark-circle-warning-20-regular",
    tone: "pending",
  },
  {
    key: "completedTask",
    label: "Completed",
    icon: "bi:clipboard-check",
    tone: "completed",
  },
];

const KpiCards = ({ counts }) => {
  const data = counts || {};

  return (
    <div className="dashboard-kpi-row">
      {KPI_ITEMS.map((item) => (
        <div className={`dashboard-kpi-card dashboard-kpi-card--${item.tone}`} key={item.key}>
          <div className="dashboard-kpi-card__text">
            <span className="dashboard-kpi-card__label">{item.label}</span>
            <span className="dashboard-kpi-card__value">
              {data[item.key] == null ? "0" : data[item.key]}
            </span>
          </div>
          <div className={`dashboard-kpi-card__icon dashboard-kpi-card__icon--${item.tone}`}>
            <Iconify icon={item.icon} width={18} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default KpiCards;
